<template>
  <div>
    <b-row class="mx-4">
      <b-col md="12" >
        <SupplierProductCard title="Alınan Ürünler" type="buy" :id="$route.params.id" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SupplierProductCard from "./SupplierProductCard";
export default {
  components:{SupplierProductCard}
}
</script>

<style scoped>

</style>